export default __webpack_public_path__ + "static/media/3_en.45fe8c23.png";